import { Button } from '@uswitch/spark'
import { Us2Rocket, Us2Filter, Us2Close } from '@uswitch/spark-icons/us2'

import smoothScrollTo from '~/utils/smooth-scroll-to'
import { trackSegment } from '~/utils/tracking'

import { MS3_PROVIDER_IDS } from './filter-ids'
import styles from './ms3.module.css'

const Ms3Banner = ({ isIntersecting, setIsIntersecting, postcode, setFilter, distanceToTable, tableTopOffset }) => {
  return (
    <>
      <div className={`${styles.filterBanner} ${isIntersecting ? '' : styles.filterBanner__mobile}`}>
        <img
          className={styles.filterBanner__image}
          alt='man looking at phone'
          src='https://img.uswitch.com/n36b8lzdmgnp/4lHRrkxvsvvtZbL9yidiH0/e0f103c436b988d76b4b079b51753ce0/image_25.png?h=250'
        />
        <div className={styles.filterBanner__text}>
          <div className={styles.filterBanner__flex}>
            <div className={styles.filterBanner__rocketContainer}>
              <Us2Rocket size={'24px'} color={'#141414'} />{' '}
              <p className={styles.filterBanner__strongText__badge}>Next gen full fibre</p>
            </div>
            <p className={styles.filterBanner__strongText__text}> now in {postcode}</p>
            <Us2Close
              size='32'
              className={`${styles.filterBanner__closeButton} ${isIntersecting ? styles.hidden : styles.visibleMobile}`}
              onClick={() => {
                setIsIntersecting(true)
              }}
            />
          </div>
          <div className={`${styles.transition} ${isIntersecting ? styles.visibleMobile : styles.hiddenMobile}`}>
            <h5 className={styles.filterBanner__headline}>You lucky so and so!</h5>
            <p className={styles.filterBanner__paragraph}>
              Get faster speeds than average on the most reliable technology
            </p>
          </div>
        </div>
        <Button
          className={styles.filterBanner__button}
          size='large'
          rightIcon={<Us2Filter size='24' />}
          variant='tertiary'
          onClick={() => {
            trackSegment('Element Clicked', {
              element_name: 'Filter Button',
              element_text: 'Filter next gen fibre',
              element_type: 'button'
            })
            setFilter({ providerIds: MS3_PROVIDER_IDS })
            setIsIntersecting(true)
            smoothScrollTo('#table-header', distanceToTable, tableTopOffset)
          }}
        >
          Filter next gen fibre
        </Button>
      </div>
    </>
  )
}

export default Ms3Banner
